module.exports = __webpack_public_path__ + "img/9b.9bb4e5a9.jpg";